<template>
  <!-- 快速通话选择 组件 -->
  <el-dialog title="" :visible.sync="WalkieQuickCallDialogVisible" width="50%" top="3%" :close-on-click-modal="false">
    <div id="setRecord">
      <div class="addRecord">
        <img @click="cancel" class="back-record" src="@/icon/back.png" alt="" />
        <span class="addRecord-title">{{ i18n.t('quickCall') }}</span>
        <i class="sys-close-btn" @click="cancel"></i>
      </div>
      <div class="group">
        <div class="select-title">{{ i18n.t('SelectMembers') }}</div>
        <el-input :placeholder="i18n.t('searchM')" v-model="addUsername" class="search-add">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="broad">
        <div v-if="ouList.length > 0">
          <elTree2
            ref="userTree"
            :data="ouList"
            :check-on-click-node="true"
            show-checkbox
            node-key="userId"
            :filter-node-method="filterNode"
            default-expand-all
            :check-strictly="true"
            :props="ouTreeProps"
          >
          </elTree2>
        </div>
        <div v-else class="setTree">
          {{ i18n.t('personalInfoPersonalSet') }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sureCall">{{ i18n.t('determine') }}</el-button>
      <el-button @click="cancel">{{ i18n.t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import elTree2 from '@/components/vTree/src/tree'
import store from '@/store/index'
import { errorCollection } from '@/api/dmp/dmpCollection'
import i18n from '@/common/i18n'

export default {
  props: {
    WalkieQuickCallDialogVisible: {
      type: Boolean,
    },
    ouList: {
      type: Array,
    },
  },
  data() {
    return {
      i18n: i18n,
      // 机构树格式
      ouTreeProps: {
        label: 'name',
        children: 'children',
      },
      addUsername: '',
    }
  },
  components: { elTree2 },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 退出快速呼叫页面
    cancel() {
      this.addUsername = ''
      this.$emit('update:WalkieQuickCallDialogVisible', false)
    },
    // 确定呼叫
    sureCall() {
      this.addUsername = ''
      // 默认第一次发起通话时 退出对讲前都可以_joinRoom
      store.commit('isCancelOne', true)

      let NodesArr = this.$refs.userTree.getCheckedNodes()
      let idArr = []
      // 处理呼叫用户数据，发送给后台
      for (let item of NodesArr) {
        idArr.push({
          helmetId: item.device.deviceName,
          userName: item.name,
        })
      }
      if (idArr.length === 0) {
        this.$message({ type: 'error', message: this.$t('PleaseSelecAtLeastOne') })
        errorCollection('语音通讯-语音通话', '快速呼叫', {
          status: 200,
          data: { state: -1, msg: '请选择至少一位群员!' },
        })
      } else {
        // 调用toDialog发送数据
        this.$emit('toDialog', 'quick', idArr)
        this.$emit('update:WalkieQuickCallDialogVisible', false)
      }
    },
  },
  watch: {
    addUsername(val) {
      // 监听新增用户查询
      this.$refs.userTree.filter(val)
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
#setRecord
  .addRecord
    position relative
    line-height 50px
    border-radius 4px
    padding 0 15px
    .back-record
      width 16px
      height 16px
      margin-right 7px
      cursor pointer
    .addRecord-title
      font-size 20px
    .sys-close-btn
      position absolute
      right 10px
      top 50%
      transform translate(0, -50%)
      display block
  .group
    // margin 10px 40px
    width 80% !important
    font-size 18px
    font-weight bold
    line-height 40px
    .select-title
      margin-top 10px
    .search-add
      font-size 18px
  .broad
    height 287px
    .el-tree
      width 80% !important
  .setTree
    height 400px
    font-size 18px
    text-align center
    line-height 100px
    color red
>>>.el-tree-node__content>label.el-checkbox
  position: absolute!important
  right: 10px!important
</style>
